var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "upgrade-tip",
      on: {
        click: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _vm.isAdvance && _vm.isCn
        ? _c("img", { attrs: { src: require("./advanced_tip.png"), alt: "" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.isAdvance && !_vm.isCn
        ? _c("img", {
            attrs: { src: require("./advanced_tip_en.png"), alt: "" }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isAdvance && _vm.isCn
        ? _c("img", {
            attrs: { src: require("./professional_tip.png"), alt: "" }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isAdvance && !_vm.isCn
        ? _c("img", {
            attrs: { src: require("./professional_tip_en.png"), alt: "" }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }